/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recover_OpenInputs */

const en_recover_open = /** @type {(inputs: Recover_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lost your passkey? Use a recovery code`)
};

const de_recover_open = /** @type {(inputs: Recover_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passkey verloren? Wiederherstellungscode verwenden`)
};

/**
* | output |
* | --- |
* | "Lost your passkey? Use a recovery code" |
*
* @param {Recover_OpenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recover_open = /** @type {((inputs?: Recover_OpenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recover_OpenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recover_open(inputs)
	return en_recover_open(inputs)
});